import {Platform, StyleSheet} from 'react-native';

import {
  black,
  chatHistoryActiveItemBackground,
  chatHistoryCardBackground,
  chatHistoryCardBorder,
  chatTableBorderSoft,
  chatTableBorderStrong,
  chatTableCellText,
  chatTableHeaderBackground,
  chatTableHeaderText,
  doctor,
  errorRed,
  neutral200,
  neutral300,
  neutral350,
  neutral400,
  neutral500,
  neutral600,
  white,
} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    paddingTop: Platform.OS === 'ios' ? 58 : 16,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: '600',
    paddingTop: 5,
  },
  headerMainContent: {
    width: '100%',
  },
  headerSubtitle: {
    fontSize: 12,
    marginTop: 0,
    marginBottom: 0,
  },
  headerRefreshText: {
    fontSize: 13,
    marginTop: 0,
    marginBottom: 0,
    lineHeight: 16,
  },
  headerTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTitleMetaContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexShrink: 1,
  },
  headerTitleInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },
  betaTag: {
    marginLeft: 4,
    marginTop: 1,
    alignSelf: 'center',
    borderRadius: 11,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: Platform.OS === 'ios' ? 3 : 2,
    minHeight: 20,
    fontSize: 11,
    fontWeight: '700',
    lineHeight: 16,
    textAlign: 'center',
  },
  infoButton: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginLeft: 4,
  },
  infoIcon: {
    fontSize: 16,
  },
  closeButton: {
    padding: 4,
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTopActionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerRefreshBelowTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 3,
  },
  historyActionContainer: {
    alignItems: 'flex-start',
    marginRight: 8,
  },
  headerActionButton: {
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  historyButtonText: {
    fontSize: 13,
    fontWeight: '600',
  },
  activeConversationBar: {
    borderBottomWidth: 1,
    paddingVertical: 10,
    paddingLeft: 16,
    paddingRight: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  activeConversationTextContainer: {
    flex: 1,
    paddingRight: 12,
    minWidth: 0,
  },
  activeConversationTitle: {
    fontSize: 15,
    fontWeight: '600',
    marginBottom: 2,
  },
  activeConversationSupportReference: {
    fontSize: 12,
    opacity: 0.72,
    flexShrink: 1,
  },
  activeConversationMetaContainer: {
    marginTop: 3,
  },
  activeConversationReferenceRow: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    maxWidth: '100%',
  },
  activeConversationSupportReferenceIcon: {
    fontSize: 12,
    marginLeft: 6,
  },
  historyPanel: {
    flex: 1,
    borderBottomWidth: 1,
    paddingHorizontal: 12,
    paddingTop: 8,
    paddingBottom: 10,
  },
  historyScroll: {
    flex: 1,
  },
  historyContent: {
    paddingBottom: 4,
  },
  historyLoadMoreIndicator: {
    paddingVertical: 12,
    minHeight: 228,
    justifyContent: 'center',
  },
  historySectionLabel: {
    fontSize: 12,
    fontWeight: '700',
    marginTop: 10,
    marginBottom: 8,
    alignSelf: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  historyEmptyStateContainer: {
    paddingVertical: 20,
    paddingHorizontal: 8,
    alignItems: 'center',
  },
  historyEmptyStateCard: {
    width: '100%',
    maxWidth: 360,
    borderWidth: 1,
    borderRadius: 14,
    paddingHorizontal: 16,
    paddingVertical: 18,
    alignItems: 'center',
  },
  historyEmptyStateAvatar: {
    width: 34,
    height: 34,
    marginBottom: 10,
  },
  historyEmptyStateTitle: {
    fontSize: 15,
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 6,
  },
  historyEmptyStateText: {
    fontSize: 13,
    textAlign: 'center',
    lineHeight: 18,
    marginBottom: 14,
  },
  historyEmptyStateButton: {
    minHeight: 34,
    borderRadius: 10,
    paddingHorizontal: 14,
    justifyContent: 'center',
    alignItems: 'center',
  },
  historyEmptyStateButtonText: {
    fontSize: 12,
    fontWeight: '700',
  },
  historyToolbar: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 8,
  },
  historyRetentionCard: {
    flexDirection: 'row',
    alignItems: 'stretch',
    borderWidth: 1,
    borderRadius: 12,
    paddingHorizontal: 12,
    paddingVertical: 10,
    marginBottom: 10,
  },
  historyRetentionAccent: {
    width: 3,
    borderRadius: 2,
    marginRight: 10,
  },
  historyRetentionContent: {
    flex: 1,
  },
  historyRetentionHeader: {
    marginBottom: 4,
  },
  historyRetentionTitle: {
    fontSize: 13,
    fontWeight: '700',
    flexShrink: 1,
  },
  historyRetentionMessage: {
    fontSize: 14,
    lineHeight: 19,
    textAlign: 'left',
  },
  historyToolbarButton: {
    width: 30,
    height: 30,
    borderRadius: 15,
    justifyContent: 'center',
    alignItems: 'center',
  },
  historyToolbarIcon: {
    fontSize: 16,
  },
  historyItem: {
    borderWidth: 1,
    borderRadius: 12,
    minHeight: 64,
    paddingHorizontal: 16,
    paddingVertical: 14,
    marginBottom: 8,
  },
  historySkeletonCard: {
    justifyContent: 'center',
  },
  historySkeletonLinePrimary: {
    height: 12,
    borderRadius: 6,
    width: '70%',
    backgroundColor: neutral400,
    marginBottom: 10,
  },
  historySkeletonLineSecondary: {
    height: 10,
    borderRadius: 5,
    width: '45%',
    backgroundColor: neutral400,
    opacity: 0.8,
  },
  historyItemRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  historyItemRowInline: {
    alignItems: 'center',
  },
  historyContentPressArea: {
    flex: 1,
    paddingRight: 8,
  },
  historyMetaColumn: {
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
  },
  historyMetaInline: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  historyItemTitle: {
    fontSize: 13,
    fontWeight: '600',
  },
  historyTitleInput: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
    fontSize: 13,
  },
  historyItemTime: {
    fontSize: 13,
    opacity: 0.65,
  },
  historyItemActions: {
    marginTop: 6,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  historyItemActionsInline: {
    marginTop: 0,
    marginLeft: 4,
  },
  historyActionButton: {
    width: 28,
    height: 28,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 10,
  },
  historyTextActionButton: {
    minWidth: 58,
    height: 30,
    borderRadius: 12,
    paddingHorizontal: 10,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
    borderWidth: 1,
    backgroundColor: white,
  },
  historyActionText: {
    fontSize: 12,
    fontWeight: '600',
  },
  historyActionIcon: {
    fontSize: 15,
  },
  newConversationButton: {
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 7,
    marginLeft: 8,
  },
  newConversationButtonText: {
    color: white,
    fontSize: 13,
    fontWeight: '600',
  },
  messagesContainer: {
    flex: 1,
  },
  messagesContent: {
    padding: 16,
    paddingBottom: 8,
  },
  messagesContentCentered: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  messageContainer: {
    marginBottom: 12,
  },
  dateTagContainer: {
    alignItems: 'center',
    marginBottom: 10,
    marginTop: 2,
  },
  dateTagText: {
    fontSize: 12,
    opacity: 0.7,
    fontWeight: '600',
  },
  userMessage: {
    alignItems: 'flex-end',
  },
  botMessage: {
    alignItems: 'flex-start',
  },
  messageRow: {
    width: '100%',
  },
  userRow: {
    maxWidth: '90%',
    alignItems: 'flex-end',
  },
  botRow: {
    maxWidth: '97%',
    alignItems: 'flex-start',
  },
  botStructuredRow: {
    maxWidth: '100%',
  },
  messageFooterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 6,
  },
  userFooterRow: {
    justifyContent: 'flex-end',
  },
  botFooterRow: {
    justifyContent: 'flex-start',
  },
  iconWrapper: {
    width: 28,
    height: 28,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
  },
  userIconWrapper: {
    marginLeft: 8,
  },
  botIconWrapper: {
    marginRight: 8,
    backgroundColor: neutral300,
  },
  botAvatar: {
    width: 32,
    height: 32,
    borderRadius: 8,
  },
  messageBubble: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 18,
    flexShrink: 1,
  },
  userMessageBubble: {
    maxWidth: '80%',
  },
  botMessageBubble: {
    maxWidth: '100%',
  },
  botStructuredMessageBubble: {
    width: '100%',
  },
  messageContent: {
    gap: 10,
  },
  userBubble: {
    borderBottomRightRadius: 4,
  },
  botBubble: {
    borderBottomLeftRadius: 4,
  },
  messageText: {
    fontSize: 16,
    lineHeight: 20,
  },
  inlineBoldText: {
    fontWeight: '700',
  },
  messageParagraph: {
    fontSize: 16,
    lineHeight: 22,
  },
  listBlock: {
    gap: 8,
  },
  listItemRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  listMarker: {
    width: 20,
    fontSize: 16,
    lineHeight: 22,
    fontWeight: '600',
  },
  listItemText: {
    flex: 1,
    fontSize: 16,
    lineHeight: 22,
  },
  tableScrollView: {
    marginHorizontal: -4,
  },
  tableContainer: {
    minWidth: '100%',
    borderWidth: 1,
    borderRadius: 14,
    overflow: 'hidden',
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  tableHeaderRow: {
    borderBottomWidth: 1,
  },
  tableBodyRow: {
    borderTopWidth: 1,
  },
  tableCell: {
    minHeight: 52,
    paddingHorizontal: 6,
    paddingVertical: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableHeaderCell: {
    paddingVertical: 10,
  },
  tableCellBorder: {
    borderRightWidth: 1,
  },
  tableHeaderText: {
    fontSize: 14,
    lineHeight: 19,
    fontWeight: '800',
    width: '100%',
    flexShrink: 1,
    flexWrap: 'wrap',
    textAlign: 'center',
  },
  tableCellText: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '700',
    width: '100%',
    flexShrink: 1,
    flexWrap: 'wrap',
    textAlign: 'center',
  },
  timestamp: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: 14,
    opacity: 0.65,
  },
  userTimestamp: {
    textAlign: 'right',
  },
  botTimestamp: {
    textAlign: 'left',
  },
  loadingContainer: {
    paddingVertical: 8,
  },
  centeredLoadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 24,
  },
  centeredLoadingIndicator: {
    marginBottom: 2,
  },
  centeredLoadingText: {
    marginTop: 10,
    fontSize: 14,
    fontStyle: 'italic',
    textAlign: 'center',
  },
  loadingRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  loadingIndicatorSlot: {
    width: 16,
    height: 16,
    marginRight: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingText: {
    flex: 1,
    fontSize: 14,
    fontStyle: 'italic',
  },
  welcomeContainer: {
    alignItems: 'center',
    paddingTop: 32,
    paddingHorizontal: 24,
  },
  welcomeAvatarImage: {
    width: 72,
    height: 72,
    borderRadius: 20,
    marginBottom: 16,
  },
  welcomeHeading: {
    fontSize: 20,
    fontWeight: '700',
    marginBottom: 8,
    textAlign: 'center',
  },
  welcomeSubtitle: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    marginBottom: 24,
  },
  welcomeSuggestionsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
  },
  welcomeSuggestionCard: {
    width: '48%',
    borderRadius: 16,
    padding: 14,
    alignItems: 'flex-start',
    borderWidth: 1.5,
    marginBottom: 10,
  },
  welcomeSuggestionLabel: {
    fontSize: 14,
    fontWeight: '600',
  },
  disclaimerText: {
    fontSize: 11,
    lineHeight: 14,
    opacity: 0.55,
    textAlign: 'center',
  },
  disclaimerContainer: {
    paddingHorizontal: 16,
    paddingTop: 3,
    paddingBottom: 2,
  },
  suggestionsContainer: {
    paddingHorizontal: 12,
    paddingBottom: 8,
  },
  suggestionsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -4,
  },
  suggestionChip: {
    borderWidth: 1,
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginHorizontal: 4,
    marginVertical: 4,
    backgroundColor: white,
    maxWidth: '100%',
  },
  suggestionChipText: {
    fontSize: 13,
    fontWeight: '600',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingHorizontal: Platform.OS === 'android' ? 12 : 16,
    paddingVertical: 12,
    borderTopWidth: 1,
  },
  textInputContainer: {
    flex: 1,
    position: 'relative',
    justifyContent: 'center',
  },
  textInput: {
    borderWidth: 1,
    borderRadius: 20,
    paddingHorizontal: Platform.OS === 'android' ? 12 : 16,
    paddingTop: Platform.OS === 'android' ? 11 : 12,
    paddingBottom: Platform.OS === 'android' ? 11 : 8,
    paddingRight: Platform.OS === 'android' ? 52 : 56,
    minHeight: Platform.OS === 'android' ? 46 : 52,
    maxHeight: 100,
    fontSize: Platform.OS === 'android' ? 15 : 16,
  },
  sendButton: {
    position: 'absolute',
    right: Platform.OS === 'android' ? 4 : 6,
    bottom: Platform.OS === 'android' ? 4 : 6,
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeIcon: {
    fontSize: 24,
  },
  sendIcon: {
    fontSize: 20,
    color: white,
  },
  feedbackRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 8,
  },
  feedbackButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 4,
    borderWidth: 1,
  },
  feedbackEmoji: {
    fontSize: 16,
  },
  infoPopoverContainer: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
    zIndex: 50,
    elevation: 50,
  },
  infoPopoverBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: black,
    opacity: 0.4,
  },
  infoPopoverSheet: {
    backgroundColor: white,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
});

interface ChatModalDynamicStyleParams {
  backgroundColor: string;
  textColor: string;
  primaryColor: string;
  bottomInset: number;
  disclaimerBottomInset: number;
  headerTopInset: number;
}

export const createDynamicStyles = ({
  backgroundColor,
  textColor,
  primaryColor,
  bottomInset,
  disclaimerBottomInset,
  headerTopInset,
}: ChatModalDynamicStyleParams) =>
  StyleSheet.create({
    containerBackground: {
      backgroundColor,
    },
    headerBorder: {
      borderBottomColor: neutral400,
    },
    headerTopInset: {
      paddingTop: headerTopInset,
    },
    headerTitleText: {
      color: textColor,
    },
    headerSubtitleText: {
      color: textColor,
      opacity: 0.6,
    },
    betaTag: {
      color: primaryColor,
      borderColor: primaryColor,
    },
    infoIcon: {
      color: textColor,
    },
    historyButtonText: {
      color: primaryColor,
    },
    closeIcon: {
      color: textColor,
    },
    activeConversationBarBorder: {
      borderBottomColor: neutral400,
    },
    activeConversationTitle: {
      color: textColor,
    },
    activeConversationSupportReference: {
      color: textColor,
    },
    activeConversationSupportReferenceIcon: {
      color: textColor,
    },
    newConversationButton: {
      backgroundColor: primaryColor,
    },
    historyPanelBorder: {
      borderBottomColor: neutral400,
    },
    historyToolbarDeleteIcon: {
      color: errorRed,
    },
    historyEmptyStateCard: {
      borderColor: chatHistoryCardBorder,
      backgroundColor: chatHistoryCardBackground,
    },
    historyEmptyStateTitle: {
      color: textColor,
    },
    historyEmptyStateText: {
      color: textColor,
      opacity: 0.78,
    },
    historyEmptyStateButton: {
      backgroundColor: white,
      borderColor: primaryColor,
      borderWidth: 1,
    },
    historyEmptyStateButtonText: {
      color: primaryColor,
    },
    historyItemActive: {
      borderColor: primaryColor,
      backgroundColor: chatHistoryActiveItemBackground,
    },
    historyItemInactive: {
      borderColor: neutral400,
      backgroundColor: white,
    },
    historyTitleInput: {
      borderColor: neutral500,
      color: textColor,
    },
    historyItemTitleActive: {
      color: primaryColor,
    },
    historyItemTitleInactive: {
      color: textColor,
    },
    historyItemTime: {
      color: textColor,
    },
    historySectionLabel: {
      color: textColor,
      opacity: 0.7,
    },
    historyRetentionCard: {
      borderColor: chatHistoryCardBorder,
      backgroundColor: chatHistoryCardBackground,
    },
    historyRetentionAccent: {
      backgroundColor: primaryColor,
    },
    historyRetentionTitle: {
      color: textColor,
    },
    historyRetentionMessage: {
      color: textColor,
      opacity: 0.72,
    },
    historyTextActionPrimary: {
      borderColor: primaryColor,
    },
    historyTextActionSecondary: {
      borderColor: neutral500,
    },
    historyActionTextPrimary: {
      color: primaryColor,
    },
    historyActionTextDefault: {
      color: textColor,
    },
    historyDeleteActionIcon: {
      color: errorRed,
    },
    userBubble: {
      backgroundColor: primaryColor,
    },
    botBubble: {
      backgroundColor: neutral200,
    },
    messageContent: {
      rowGap: 10,
    },
    userMessageText: {
      color: white,
    },
    botMessageText: {
      color: textColor,
    },
    timestampText: {
      color: textColor,
    },
    dateTagText: {
      color: textColor,
    },
    tableContainer: {
      borderColor: chatTableBorderStrong,
      backgroundColor: white,
    },
    tableHeaderRow: {
      backgroundColor: chatTableHeaderBackground,
      borderBottomColor: chatTableBorderStrong,
    },
    tableBodyRow: {
      backgroundColor: white,
      borderTopColor: chatTableBorderSoft,
    },
    tableCellBorder: {
      borderRightColor: chatTableBorderSoft,
    },
    tableHeaderText: {
      color: chatTableHeaderText,
    },
    tableCellText: {
      color: chatTableCellText,
    },
    messagesContentInset: {
      paddingBottom: bottomInset + 24,
    },
    welcomeHeadingText: {
      color: textColor,
    },
    welcomeSubtitleText: {
      color: textColor,
      opacity: 0.6,
    },
    welcomeSuggestionCard: {
      backgroundColor: white,
      borderColor: neutral350,
    },
    welcomeSuggestionLabel: {
      color: textColor,
    },
    loadingText: {
      color: textColor,
    },
    disclaimerText: {
      color: textColor,
    },
    suggestionChip: {
      borderColor: primaryColor,
    },
    suggestionChipText: {
      color: primaryColor,
    },
    suggestionChipEnabled: {
      opacity: 1,
    },
    suggestionChipDisabled: {
      opacity: 0.6,
    },
    inputContainerInset: {
      borderTopColor: neutral400,
    },
    disclaimerContainerInset: {
      paddingBottom: disclaimerBottomInset,
    },
    textInput: {
      borderColor: neutral400,
      color: textColor,
      backgroundColor: doctor,
    },
    sendButtonEnabled: {
      backgroundColor: primaryColor,
    },
    sendButtonDisabled: {
      backgroundColor: neutral600,
    },
    infoPopoverContentInset: {
      paddingBottom: bottomInset,
    },
    feedbackButtonDefault: {
      borderColor: neutral400,
      backgroundColor: 'transparent',
    },
    feedbackButtonSelected: {
      borderColor: primaryColor,
      backgroundColor: `${primaryColor}22`,
    },
  });
